<template>
	<div>
		<div v-if="!agentFactor">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;" v-else>
			<div style="display: flex;width: 100%;margin-bottom: 30px;">
				<div style="text-align: right;">
					<img :src="agentFactor.agent.metaData && agentFactor.agent.metaData.thumbnailBase64 ? agentFactor.agent.metaData.thumbnailBase64 : `/logo.png`" style="max-width: 100px" alt="App Logo" />
				</div>
				<div style="flex-grow: 2;text-align: center;">
					<div style="font-size: 18px;">{{ agentFactor.agent.businessName }}</div>
					<div style="font-size: 16px;">صورتحساب فروش</div>
				</div>
				<div style="text-align: left;font-size: 12px;">
					تاریخ چاپ: {{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }}
				</div>
			</div>

			<div style="display: flex;text-align: right;width: 100%;font-size: 12px;border: 2px solid #000;margin-bottom: 15px;">
				<div style="padding: 8px; border-left: 1px solid #000;">
					تاریخ فاکتور: {{ agentFactor.createAt_Persian.date.toPersianDigits() }}
				</div>
				<div style="padding: 8px; border-left: 1px solid #000;">
					شماره سیستمی: {{ agentFactor.code.toString().toPersianDigits() }}
				</div>
				<div style="padding: 8px;">
					شماره فرعی: {{ agentFactor.userCode.toPersianDigits() }}
				</div>
			</div>

			<div style="display: flex;text-align: right;width: 100%;font-size: 12px;border: 2px solid #000;margin-bottom: 15px;">
				<div style="padding: 8px; border-left: 1px solid #000;">
					فروشنده: {{ agentFactor.agent.businessName }}
				</div>
				<div style="padding: 8px; border-left: 1px solid #000;">
					شماره تماس: {{ agentFactor.agent.mobile.toPersianDigits() }}
				</div>
				<div style="padding: 8px;">
					آدرس: {{ agentFactor.agent.address.toPersianDigits() }}
				</div>
			</div>

			<div style="border: 2px solid #000;margin-bottom: 25px;font-size: 12px;">
				<div style="display: flex;flex-wrap: wrap; text-align: right;width: 100%;border-bottom: 1px solid #000;">
					<div style="padding: 8px; border-left: 1px solid #000;">
						مشتری: {{ agentFactor.member.fullName }}
					</div>
					<div style="padding: 8px; border-left: 1px solid #000;">
						کد ملی: {{ agentFactor.member.nationalCode.toPersianDigits() }}
					</div>
					<div style="padding: 8px; border-left: 1px solid #000;">
						شماره تماس: {{ agentFactor.member.mobile.toPersianDigits() }}
					</div>
				</div>
				<div style="padding: 8px;">
					آدرس: {{ agentFactor.member.address.toPersianDigits() }}
				</div>
			</div>

			<div style="font-size: 13px;margin-bottom: 5px;">شرح فاکتور:</div>
			<div style="white-space: pre-line;padding: 10px;min-height: 100px;margin-bottom: 25px;border:1px solid #000">
				{{ agentFactor.description }}
			</div>

			<div style="display: flex;justify-content: space-between;padding: 20px">
				<div>امضا فروشنده</div>
				<div>امضا مشتری</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'AgentFactorPrintHtml',
		components: {
		},
		props: {
			id: {
				type: String,
			}
		},
		data: () => ({
			html: '',
			agentFactor: null,
		}),
		mounted() {
			this.fillHtml()
		},
		computed: {
			...get('siteConfig', [
				'fullTitle'
			]),
			...get('appSettings', [
				'settings'
			]),
			businessTitle() {
				return this.settings?.businessTitle || this.fullTitle
			},

		},
		methods: {
			fillHtml() {
				this.getAgentFactor().then(res => {
					this.agentFactor = res
					this.$nextTick(() => {
						this.$emit('ready')
					})
				})
			},
			getAgentFactor() {
				return api.get('member/AgentFactor/get/' + this.id)
					.catch(err => {
						toast.error(err.message)
					})
			}
		}
	}
</script>
<style scoped></style>